import { useDateRange } from './DateRangeProvider';
import { Next, Previous } from './Stepper';
import { getStepper } from './steppers';
import type { DateRange } from './types';
import { toInputFormat } from './utils';

const DateRangeStepper = () => {
  const { value, setValue } = useDateRange();
  const stepper = getStepper(value);

  const onClick = (range: DateRange) => {
    setValue([toInputFormat(range.from), toInputFormat(range.to)]);
  };

  return (
    <>
      <Previous stepper={stepper} onClick={onClick} />
      <Next stepper={stepper} onClick={onClick} />
    </>
  );
};

export default DateRangeStepper;
